import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, NgForm, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { ICustomer, ILead } from 'app/core/shared-services/shared-interface.types';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';


@Component({
  selector: 'app-confirm-details',
  standalone: true,
  imports: [CommonModule, MatRadioModule, MatIconModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule],
  templateUrl: './confirm-details.component.html',
  styleUrls: ['./confirm-details.component.scss']
})
export class ConfirmDetailsComponent implements OnInit {

  @Input() lead: ILead;

  @ViewChild('yourDetailsNgForm') yourDetailsNgForm: NgForm;

  @Output() confirmDetailsEvent = new EventEmitter<any>();

  public CustomerType: string = 'Individual';
  private customerAccount: ICustomer;


  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _sharedMethods: SharedMethodsModule
    
  ) {
    this.yourDetailsForm = this._formBuilder.group({
      BusinessName: [''],
      BusinessRegistration: [''],
      VatNumber: [''],
      FirstName: [''],
      Surname: [''],
      EmailAddress: [''],
      IDNumber: [''],
      MobileNumber: [''],
      AlternativeNumber: [''],
      CustomerType: ['']
    });
   }

  public yourDetailsForm: UntypedFormGroup;

  async ngOnInit() {

    await this._sharedMethods.getCustomerAccount().then(async (res) =>{
      this.customerAccount = res?.result;
      this.yourDetailsForm.get('FirstName').setValue(this.customerAccount?.PrimaryContactName);
      this.yourDetailsForm.get('Surname').setValue(this.customerAccount?.PrimaryContactLastName);
      this.yourDetailsForm.get('EmailAddress').setValue(this.customerAccount?.PrimaryContactEmail);
      this.yourDetailsForm.get('MobileNumber').setValue(this.customerAccount?.PrimaryContactMobile);
      this.yourDetailsForm.get('IDNumber').setValue(this.customerAccount?.IDNumber);
      this.customerType(null, this.customerAccount?.CustomerType);
    })

    this.isFormValid();
    
  }

  // ngOnChanges() {

  //   this.yourDetailsForm.get('FirstName').setValue(this.customerAccount?.PrimaryContactName);
  //   this.yourDetailsForm.get('Surname').setValue(this.customerAccount?.PrimaryContactLastName);
  //   this.yourDetailsForm.get('EmailAddress').setValue(this.customerAccount?.PrimaryContactEmail);
  //   this.yourDetailsForm.get('MobileNumber').setValue(this.customerAccount?.PrimaryContactMobile);
  //   this.yourDetailsForm.get('IDNumber').setValue(this.customerAccount?.IDNumber);
  //   this.customerType(null, this.customerAccount?.CustomerType);
  // }

// -----------------------------------------------------------------------------------------------------
// @ Public methods
// -----------------------------------------------------------------------------------------------------

  public customerType(event?: any, value?: string){
    if(event !== null) {
      this.CustomerType = event.value;
    } else {
      this.CustomerType = value;
    }

    if(this.CustomerType == 'Individual') {
      // make Individual form fields required
      this.yourDetailsForm.get('FirstName').setValidators([Validators.required]);
      this.yourDetailsForm.get('FirstName').updateValueAndValidity();

      this.yourDetailsForm.get('Surname').setValidators([Validators.required]);
      this.yourDetailsForm.get('Surname').updateValueAndValidity();

      this.yourDetailsForm.get('BusinessName').clearValidators();
      this.yourDetailsForm.get('BusinessName').updateValueAndValidity();

      this.yourDetailsForm.get('BusinessRegistration').clearValidators();
      this.yourDetailsForm.get('BusinessRegistration').updateValueAndValidity();

      this.yourDetailsForm.get('VatNumber').clearValidators();
      this.yourDetailsForm.get('VatNumber').updateValueAndValidity();

      this.yourDetailsForm.get('BusinessName').clearValidators();
      this.yourDetailsForm.get('BusinessName').updateValueAndValidity();

      this.yourDetailsForm.get('BusinessName').clearValidators();
      this.yourDetailsForm.get('BusinessName').updateValueAndValidity();
      




      this.yourDetailsForm.value.CustomerType = this.CustomerType
    } else {
      // make Business form fields required
      this.yourDetailsForm.get('BusinessName').setValidators([Validators.required]);
      this.yourDetailsForm.get('BusinessName').updateValueAndValidity();

      this.yourDetailsForm.get('BusinessRegistration').setValidators([Validators.required]);
      this.yourDetailsForm.get('BusinessRegistration').updateValueAndValidity();

      this.yourDetailsForm.get('VatNumber').setValidators([Validators.required]);
      this.yourDetailsForm.get('VatNumber').updateValueAndValidity();

      this.yourDetailsForm.get('FirstName').setValidators([Validators.required]);
      this.yourDetailsForm.get('FirstName').updateValueAndValidity();

      this.yourDetailsForm.get('Surname').setValidators([Validators.required]);
      this.yourDetailsForm.get('Surname').updateValueAndValidity();

      this.yourDetailsForm.value.CustomerType = this.CustomerType
    }

    
  }

  public isFormValid() {
    if (this.yourDetailsForm.valid) {
      this.confirmDetailsEvent.emit(this.yourDetailsForm.value);
    }
  }

}
